// This is meant for smaller KV storage, for larger storage use ./kvStorage.ts

import { Capacitor } from '@capacitor/core'
import { Preferences } from '@capacitor/preferences'

const isElectron = typeof window !== 'undefined' && !!window.ipcStore
const isMobile = Capacitor.getPlatform() === 'android' || Capacitor.getPlatform() === 'ios'

export const preferenceStorage = {
  get: async (key: string) => {
    if (isElectron) {
      return window.ipcStore.get(key)
    } else if (isMobile) {
      const result = await Preferences.get({ key })
      if (result.value === null) return null
      let finalResult: any = null
      try {
        finalResult = JSON.parse(result.value)
      } catch {
        finalResult = result.value
      }
      return finalResult
    } else {
      // Browser mode: localStorage returns strings, need to parse JSON
      const value = localStorage.getItem(key)
      if (value === null) return null
      try {
        return JSON.parse(value)
      } catch {
        return value
      }
    }
  },
  set: async (key: string, value: any) => {
    if (isElectron) {
      await window.ipcStore.set(key, value)
    } else if (isMobile) {
      const stringValue = typeof value === 'string' ? value : JSON.stringify(value)
      await Preferences.set({ key, value: stringValue })
    } else {
      // Browser mode: localStorage needs strings, stringify objects
      const stringValue = typeof value === 'string' ? value : JSON.stringify(value)
      localStorage.setItem(key, stringValue)
    }
  },
  delete: async (key: string) => {
    if (isElectron) {
      await window.ipcStore.delete(key)
    } else if (isMobile) {
      await Preferences.remove({ key })
    } else {
      localStorage.removeItem(key)
    }
  },
  deleteAll: async () => {
    if (isElectron) {
      await window.ipcStore.deleteAll()
    } else if (isMobile) {
      await Preferences.clear()
    } else {
      localStorage.clear()
    }
  }
}
